import client from './client';

// 이마비율 진단 단일 결과 불러오기
export const getForeheadResult = async ({ user_id, diagnosis_id }) => {
  await new Promise((resolve) => setTimeout(() => resolve(), 300));
  return client.get('/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id);
};

// 이마비율 최신 진단 결과 불러오기
export const getForeheadResultRecent = ({ user_id }) =>
  client.get('/my/user/' + user_id + '/m/diagnosis/recent');

// 이마비율 진단 히스토리 불러오기
export const getForeheadHistory = ({ user_id, skip, take }) =>
  client.get(
    '/my/user/' +
      user_id +
      '/m/diagnosis/histories?skip=' +
      skip +
      '&take=' +
      take,
  );

// 통합 진단 내역들 결과 불러오기
export const getAllDiagnosisHistory = ({ user_id }) =>
  client.get('/my/user/' + user_id + '/diagnoses?type=DETAIL');

// 진단 내역 삭제하기
// 진단 내역 삭제하기
export const deleteForeheadResult = async ({
  user_id,
  diagnosis_id,
  skip,
  take,
}) => {
  try {
    // 진단 data 를 삭제한 후, history를 다시 get 함
    const response = await client.delete(
      '/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id,
    );

    if (response.status === 200) {
      return client.get(
        '/my/user/' +
          user_id +
          '/m/diagnosis/histories?skip=' +
          skip +
          '&take=' +
          take,
      );
    }
  } catch (e) {
    console.log(e);
  }
};

// m진단내의 이마면적, 비율, 점수, 종합 점수(남/여) 정보 수정하기
export const updateForeheadResult = async ({
  user_id,
  diagnosis_id,
  forehead_area,
  forehead_area_ratio,
  forehead_area_score,
  final_subscore_forhead_man,
  final_subscore_forhead_woman,
  final_subscore_length,
  final_subscore_young,
  final_subscore_shape,
  final_total_score_man,
  final_total_score_woman,
}) => {
  try {
    // 진단 data 를 업데이트 한 후, ranking 정보 업데이트를 위해 ranking API 를 호출하여 반환함
    const response = await client.put(
      '/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id,
      {
        forehead_area: forehead_area,
        forehead_area_ratio: forehead_area_ratio,
        forehead_area_score: forehead_area_score,
        final_subscore_forhead_man: final_subscore_forhead_man,
        final_subscore_forhead_woman: final_subscore_forhead_woman,
        final_subscore_length: final_subscore_length,
        final_subscore_young: final_subscore_young,
        final_subscore_shape: final_subscore_shape,
        final_total_score_man: final_total_score_man,
        final_total_score_woman: final_total_score_woman,
      },
    );

    if (response.status === 200) {
      const updatedResult = await client.get(
        '/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id,
      );
      console.log(
        'DIAGNOSIS API!!! foreheadArea request(' +
          forehead_area +
          '), updated(' +
          (updatedResult && updatedResult.data
            ? updatedResult.data.forehead_area
            : 'no data...') +
          ')',
      );
      return client.get(
        '/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id + '/rank',
      );
    }
  } catch (e) {
    console.log(e);
  }
};

// 진단 내역의 이마면적 랭킹 정보 불러오기
export const getForeheadRank = ({ user_id, diagnosis_id }) => {
  console.log('FOREHEAD TEST -------> user_id', user_id);
  console.log('FOREHEAD TEST -------> diagnosis_id', diagnosis_id);
  return client.get(
    '/my/user/' + user_id + '/m/diagnosis/' + diagnosis_id + '/rank',
  );
};

export const makeForeheadShareId = ({ user_id, diagnosis_id, data }) =>
  client.post(
    '/my/user/' +
      user_id +
      '/m/diagnosis/' +
      diagnosis_id +
      '/share/face-ratio',
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    },
  );

export const makeSimulationShareId = ({ user_id, diagnosis_id, data }) =>
  client.post(
    '/my/user/' +
      user_id +
      '/m/diagnosis/' +
      diagnosis_id +
      '/share/forehead-simulation',
    data,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    },
  );

export const enterForeheadChallenge = async ({ user_id, data }) => {
  await new Promise((resolve) => setTimeout(() => resolve(), 300));

  return client.post(
    '/my/user/' + user_id + '/forehead-challenge/entry',
    data,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );
};

export const getForeheadChallenge = ({ user_id }) =>
  client.get('/my/user/' + user_id + '/forehead-challenge/info');
